export default "__VITE_PUBLIC_ASSET__0485bb69__"